export default {
    clicalTask: null,
    patientsFlag:null,
    appointmentCount:null,
    escalationCount:null,
    escalationRecord:null,
}